import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react";
import axios from "axios";
// import { toast } from 'react-toastify';
import { useAuthContext } from "./AuthContext.tsx";
import { useNavigate } from "react-router-dom";

const LiveViewDataContext = createContext(null);

export const useLiveViewDataContext = () => {
  const context = useContext(LiveViewDataContext);
  return context;
};

export const LiveViewDataContextProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const storedToken = localStorage.getItem("token");
  const [currentStoreIndex, setCurrentStoreIndex] = useState(0);
  const [currentCameraIndex, setCurrentCameraIndex] = useState(0);
  const [videoData, setVideoData] = useState("");
  const [videoHeader, setVideoHeader] = useState("");
  const [thumbNail, setThumbNail] = useState("");
  const [listDialogVisible, setListDialogVisible] = useState(false);
  // const [paused, setPaused] = useState(false);
  const [loadingThumbnail, setLoadingThumbnail] = useState(true);
  const [activeListCameraKey, setActiveListCameraKey] = useState(null);
  const navigate = useNavigate();

  const { auth } = useAuthContext();

  // const setInitialVideo = useCallback((data, storeIdx, camIdx) => {
  //     if (data && data.length > 0) {
  //         const store = data[storeIdx];
  //         if (store && store.cam_list.length > 0) {
  //             const camera = store.cam_list[camIdx];
  //             setVideoData(`${store.store_host}${camera.hls_url}`);
  //             setVideoHeader(`${store.store_name}, ${camera.cam_name}`);
  //             setThumbNail(`${store.store_host}${camera.mjpeg_url}`);
  //             setCurrentStoreIndex(storeIdx);
  //             setCurrentCameraIndex(camIdx);
  //             setLoadingThumbnail(true);
  //             setPaused(false);

  //             // Set the active camera key when a camera is clicked
  //             const cameraKey = `${store.store_name}-${camera.cam_name}`;
  //             setActiveListCameraKey(cameraKey);
  //         }
  //     }
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!auth) {
        navigate("/login");
        return;
      }

      // prevent redundant fetching
      if (data) return;

      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/cust-portal/media-service-configs`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        setData(response?.data);
        setIsLoading(false);
      } catch (error) {
        //  console.log("Something went wrong while fetching Live data!");
        //  toast.error("Something went wrong while fetching data!");
        setIsLoading(false);
      }
    };
    fetchData();
  }, [auth, storedToken]);

  //Memoized context value to prevent unnecessary re-renders
  const value = useMemo(
    () => ({
      // Static / fetched data
      data,
      isLoading,

      // Video / UI state
      videoData,
      setVideoData,
      videoHeader,
      setVideoHeader,
      thumbNail,
      setThumbNail,
      listDialogVisible,
      setListDialogVisible,
      loadingThumbnail,
      setLoadingThumbnail,

      // Camera navigation
      currentStoreIndex,
      setCurrentStoreIndex,
      currentCameraIndex,
      setCurrentCameraIndex,

      // Active camera
      activeListCameraKey,
      setActiveListCameraKey,
    }),
    [
      data,
      isLoading,
      videoData,
      videoHeader,
      thumbNail,
      listDialogVisible,
      loadingThumbnail,
      currentStoreIndex,
      currentCameraIndex,
      activeListCameraKey,
    ]
  );

  return (
    <LiveViewDataContext.Provider value={value}>
      {children}
    </LiveViewDataContext.Provider>
  );
};
